<micro-select-combo #sel
              placeholder="Notification Type"
              [mode]="mode"
              [(id)]="notificationType"
              (idChange)="change($event)"
              [required]="required"
              [options]="options"
              [disabled]="disabled"
>
</micro-select-combo>
